import { defineStore } from "pinia";
import { usePensionOptionsStore } from "./pensionOptions";
import { useAboutYouStore } from "./aboutYou";
import { useDailyActivitiesStore } from "./dailyActivities";
import { useYourDetailsStore } from "./yourDetails";
import { useDependantAboutYouStore } from "./dependantAboutYou";
import { useDependantDailyActivitiesStore } from "./dependantDailyActivities";
import { useFinallyStore } from "./finally";
import { useConfigStore } from "./config";
import { computed, ComputedRef } from "vue";
import { useRoute } from "vue-router";

type SessionTimeoutStore = {
    activeOverlay: boolean,
    currentTime: number,
    endTime: number,
}

export const useSessionTimeoutStore = defineStore("sessionTimeout", {
    state: () : SessionTimeoutStore => {
        const config = useConfigStore();
        return {
            activeOverlay: false,
            currentTime: Number(new Date()),
            endTime: Number(new Date()) + config.sessionTimeoutWarning + config.sessionTimeoutPage,
        };
    },
    actions: {
        touchSession() {
            const config = useConfigStore();
            this.endTime = Number(new Date()) + config.sessionTimeoutWarning + config.sessionTimeoutPage;
        },
        resetSession() {
            const pensionOptionsStore = usePensionOptionsStore();
            const aboutYouStore = useAboutYouStore();
            const dailyActivitiesStore = useDailyActivitiesStore();
            const yourDetailsStore = useYourDetailsStore();
            const dependantAboutYouStore = useDependantAboutYouStore();
            const dependantDailyActivitiesStore = useDependantDailyActivitiesStore();
            const finallyStore = useFinallyStore();

            pensionOptionsStore.$reset();
            aboutYouStore.$reset();
            yourDetailsStore.$reset();
            dailyActivitiesStore.$reset();
            dependantAboutYouStore.$reset();
            dependantDailyActivitiesStore.$reset();
            finallyStore.$reset();
        },
        showTimeoutWarning(): boolean {
            const config = useConfigStore();
            return this.currentTime >= this.endTime - config.sessionTimeoutWarning;
        },
        shouldShowTimeoutWarning() : boolean {
            const route = useRoute();
            return this.showTimeoutWarning() && route.name !== "session_timeout";
        },

        getTimeLeft(): ComputedRef<string> {
            const timeLeft = computed(() => {
                const remainingSeconds = Math.max(
                    0,
                    Math.floor((this.endTime - this.currentTime) / 1000),
                );
                const minutes = String(Math.floor(remainingSeconds / 60)).padStart(2, "0");
                const seconds = String(remainingSeconds % 60).padStart(2, "0");
                return `${minutes}m ${seconds}s`;
            });
            return timeLeft;
        },
    },
});
